import { createFileRoute, Link } from "@tanstack/react-router";
import { BlogPostForm } from "@/components/admin/BlogPostForm";

export const Route = createFileRoute("/admin/blog/new")({
  component: NewBlogPost,
});

function NewBlogPost() {
  return (
    <div>
      <Link to="/admin/blog" className="text-sm text-muted-foreground hover:text-foreground">
        ← Back to blog
      </Link>
      <h1 className="mt-3 font-display text-3xl font-semibold tracking-tight text-foreground">
        New post
      </h1>
      <div className="mt-8">
        <BlogPostForm />
      </div>
    </div>
  );
}
